import { createActionGroup, emptyProps } from '@ngrx/store';

export const SharedActions = createActionGroup({
  source: 'Shared',
  events: {
    'Reset reducer': emptyProps()
  }
});

export const AnonymousVoucherActions = createActionGroup({
  source: 'Anonymous voucher',
  events: {
    'Anonymous voucher is released': emptyProps(),
    'Reset state on anonymous voucher redeem': emptyProps()
  }
});
